<template>
    <div>
        <fieldset id="formFlight">
            <h2>Flight</h2>
            <b-form-group
                id="countryOfDeparture-group"
                label="Country of Departure:"
                label-for="countryOfDeparture"
            >
                <b-form-select  id="countryOfDeparture" v-model="formData.countryOfDeparture" :options="countryOfDepartureOptions" required @change="checkOthers"></b-form-select>
            </b-form-group>
            <b-form-group
                id="countryOfDepartureOthers-group"
                label="Other Country of Departure:"
                label-for="countryOfDepartureOthers"
                v-if="formData.countryOfDeparture == 'Others'"
            >
                <b-form-input
                id="countryOfDepartureOthers"
                v-model="formData.countryOfDepartureOthers"
                type="text"
                
                ></b-form-input>
            </b-form-group>
            <div class="flightGroup">
                <h4>Singapore Airlines Seats Available:</h4>
                <b-table responsive striped :items="flight_singaporeAir"></b-table>
                <h4>Air China Seats Available:</h4>
                <b-table responsive striped :items="flight_airChina"></b-table>
                
                <h6><small>Note:</small></h6>
                <ul>
                    <li>Flight Schedule subject to change without prior notice. Beijing and Singapore are in same time zone.</li>
                    <li>All timing shown in local time.</li>
                    <li>Flying time is estimated 6hours 10mins.</li>
                </ul>
            </div>
            <b-form-group
                id="flight-group"
                label="Select Preferred Flight:"
                label-for="flight"
            >
                <b-form-select id="flight" v-model="formData.flight" :options="flightOptions" required></b-form-select>
            </b-form-group>
            <b-form-group
                id="frequentFlyerType-group"
                label="Airline Frequent Flyer Type:"
                label-for="frequentFlyerType"
            >
                <b-form-input
                id="frequentFlyerType"
                v-model="formData.frequentFlyerType"
                type="text"
                
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="frequentFlyerNumber-group"
                label="Airline Frequent Flyer Number:"
                label-for="frequentFlyerNumber"
            >
                <b-form-input
                id="frequentFlyerNumber"
                v-model="formData.frequentFlyerNumber"
                type="text"
                
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="requests-group"
                label="Special Requests:"
                label-for="requests"
            >
                <b-form-textarea
                id="requests"
                v-model="formData.requests"
                placeholder="(e.g. dietary, seat preference, trip extension etc)"
                rows="8"
                max-rows="6"
                ></b-form-textarea>
            </b-form-group>
            <b-form-group
                id="flightItinerary-group"
                label="Please Attach Your Flight Itinerary:"
                label-for="flightItinerary"
                description="File types supported include pdf only"
            >
                <b-form-file
                    v-model="formData.flightItinerary"
                    :state="Boolean(formData.flightItinerary)"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="PDF supported only"
                    ></b-form-file>
                
            </b-form-group>
            
            
        </fieldset>
    </div>
</template>

<script>

export default {
    name: 'FormFlight',
    props: [
        'formData'
    ],
    methods: {
        checkOthers() {
            //window.console.log(this.formData.flight.frequentFlyerType);
            // if (this.formData.flight.countryOfDeparture != 'Others') {
            //     this.formData.flight.countryOfDepartureOthers = '';
            // }
            
        }
    },
    data() {
        return {
            countryOfDepartureOptions: [
                { value: null, text: 'Please select an option' },
                { value: 'Singapore', text: 'Singapore' },
                { value: 'Japan', text: 'Japan' },
                { value: 'Thailand', text: 'Thailand' },
                { value: 'India', text: 'India' },
                { value: 'China', text: 'China' },
                { value: 'Germany', text: 'Germany' },
                { value: 'France', text: 'France' },
                { value: 'Austria', text: 'Austria' },
                { value: 'USA', text: 'USA' },
                { value: 'Others', text: 'Others' }
            ],
            flightOptions: [
                { value: null, text: 'Please select an option' },
                { value: 'Singapore Airlines', text: 'Singapore Airlines' },
                { value: 'Air China', text: 'Air China' }
            ],
            flight_singaporeAir: [
                {
                    date: 'Daily',
                    sector: 'SIN-Beijing',
                    flight_no: 'SQ 802',
                    departure: '0830',
                    arrival: '1440',
                    duration: '6hrs 10mins'
                },
                {
                    date: 'Daily',
                    sector: 'SIN-Beijing',
                    flight_no: 'SQ 807',
                    departure: '1630',
                    arrival: '2300',
                    duration: '6hrs 30mins'
                }
            ],
            flight_airChina: [
                {
                    date: 'Daily',
                    sector: 'SIN-Beijing',
                    flight_no: 'CA 976',
                    departure: '0930',
                    arrival: '1615',
                    duration: '6hrs 10mins'
                },
                {
                    date: 'Daily',
                    sector: 'SIN-Beijing',
                    flight_no: 'CA 969',
                    departure: '1535',
                    arrival: '2140',
                    duration: '6hrs 5mins'
                }
            ]
        };
    }
}
</script>

<style lang="less" scoped>

</style>